// libs
import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

// hook
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// styles
import {
  ReviewSummaryContainer,
  RatingCount,
  BasedOnLight,
  RatingWrapper,
  ScrollToElementById,
} from './styles';

// selector
import { getReviewSummary } from 'shared/store/details/selectors';

// icons
import StarRating from '@nykaa/ui-components/Icons/star-filled';

interface Review {
  star_rating: number;
  review_count: number;
  star_rating_count: number;
  show_ratings: boolean;
}

const basedOn = (count: number) => `Based on ${count} ratings`;

const STAR_RATING_SIZE = '20px';

const RATING_REVIEW_CONFIG = 'ratingReviewEnabled';

function RatingSummary() {
  const { star_rating, star_rating_count, show_ratings, review_count }: Review =
    useSelector(getReviewSummary);
  const isDwebRatingReviewsEnabled = get(useRemoteConfig(RATING_REVIEW_CONFIG), 'desktop', false);

  if (!star_rating || !isDwebRatingReviewsEnabled || !show_ratings) return null;
  const starRating = Number(star_rating).toFixed(1);

  return (
    <ScrollToElementById
      ariaDescribedBy="rating-count"
      ariaLabel={basedOn(star_rating_count)}
      targetId="customer-review-section"
    >
      <ReviewSummaryContainer disableCursor={review_count < 1}>
        <RatingWrapper id="rating-count" data-test="rating-wrapper">
          <RatingCount>{starRating}</RatingCount>
          <StarRating size={STAR_RATING_SIZE} />
        </RatingWrapper>
        <BasedOnLight data-test="basedOn-light">{basedOn(star_rating_count)}</BasedOnLight>
      </ReviewSummaryContainer>
    </ScrollToElementById>
  );
}

export default RatingSummary;
